//
// KPICellController.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./RendererManagerController";
import "./KPIElementController";

var KPICellController = createModule("BIRD::KPICellController", ["BIRD::BIRDModelController","BIRD::RendererManagerController"], EventDispatcher, [
    ,
    ,
    ,
    {
        parentController: 1,
        rowIndex: 3,
    },
    {
        getLabel: [7],
    },
    {
        _create: [4],
    },
    ,
]);
export default KPICellController;
